module.exports = __webpack_public_path__ + "static/media/group-96-1.2b7e5c31.svg";